import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import OpportunityBoardView from './OpportunityBoardView.vue';

// Same gate and audience as Contacts: a deal is a contact's, and the people who
// work the pipeline are the people who work the address book.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/opportunities'),
    name: 'opportunities_index',
    meta: {
      featureFlag: FEATURE_FLAGS.CRM,
      permissions: ['administrator', 'agent', 'contact_manage'],
    },
    component: OpportunityBoardView,
  },
];

export default { routes };
